<template>
  <div>
    <list
      row-key="PlanId"
      ref="list"
      light-row
      :page="page"
      show-checkbox
      :show-query="showQuery"
      :get-data-func="api.getWorkDocTestList"
      @row-select="onSelect"
      v-if="trendShow"
      urlHash="production/reportmanagement/qualityinspection/toCheck"
      @check-change="onCheck"
      :tempParams="tempParams"
      @getDataEnd="getDataEnd"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <el-tab-pane label="注塑质检" name="0"></el-tab-pane>
          <!-- <el-tab-pane label="特殊工艺质检" name="1"></el-tab-pane>
          <el-tab-pane label="配件装配质检" name="2"></el-tab-pane>
          <el-tab-pane label="产品装配质检" name="3"></el-tab-pane>
          <el-tab-pane label="产品组合质检" name="4"></el-tab-pane> -->

          <el-tab-pane v-for="(item, index) in machiningStageList" :key="index" :label="item.Name + '质检'" :name="item.MachiningStageId + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <info1 ref="info0" v-if="tabName == '0'" style="margin-top: 20px" />
    <info2 ref="info1" v-else style="margin-top: 20px" />
    <!-- <info3 ref="info2" v-if="tabName == '2'" style="margin-top: 20px" />
    <info4 ref="info3" v-if="tabName == '3'" style="margin-top: 20px" />
    <info5 ref="info4" v-if="tabName == '4'" style="margin-top: 20px" /> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

import info1 from '@/components/production/reportmanagement/qualityinspection/toCheck/info/info1'
import info2 from '@/components/production/reportmanagement/qualityinspection/toCheck/info/info2'
import info3 from '@/components/production/reportmanagement/qualityinspection/toCheck/info/info3'
import info4 from '@/components/production/reportmanagement/qualityinspection/toCheck/info/info4'
import info5 from '@/components/production/reportmanagement/qualityinspection/toCheck/info/info5'

export default {
  mixins: [listMixin],
  components: {
    list,
    info1,
    info2,
    info3,
    info4,
    info5
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pr/test').default,
      formApi: require('@/api/sy/formSetting').default,
      tableApi: require('@/api/sy/tableSetting').default,
      queryApi: require('@/api/sy/selectSetting').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      trendShow: true,
      tabName: '0',
      mode: 1,
      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      checkList: [],
      tempParams: {
        Stage: 0
      },
      workInfo: [],
      machiningStageList: []
    }
  },
  mounted() {},
  created() {
    this.machiningStageApi.list({ Status: 1, Universal: true }).then(res => {
      this.machiningStageList = res.Data
    })
  },
  methods: {
    getDataEnd() {
      this.workInfo = []
      if (this.tabName === '0') {
        this.$refs['info0'].setData(this.workInfo)
      } else {
        this.$refs['info1'].setData(this.workInfo)
      }
    },
    // getDataEnd(resData) {
    //   console.log("getDataEnd ==== resData", resData);
    //   let Combination = [];
    //   let Assembling = [];
    //   let Parts = [];
    //   let Special = [];
    //   let Injection = [];

    //   let data = resData;
    //   let length = data.length;

    //   for (let i = 0; i < length; ++i) {
    //     let stage = data[i].Stage;
    //     switch (stage) {
    //       case 0:
    //         Injection.push(data[i]);
    //         break;
    //       case 1:
    //         Special.push(data[i]);
    //         break;
    //       case 2:
    //         Parts.push(data[i]);
    //         break;
    //       case 3:
    //         Assembling.push(data[i]);
    //         break;
    //       case 4:
    //         Combination.push(data[i]);
    //         break;
    //     }
    //   }

    //   this.Combination = Combination;
    //   this.Assembling = Assembling;
    //   this.Parts = Parts;
    //   this.Special = Special;
    //   this.Injection = Injection;

    //   if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
    //   if (this.tabName === "1") this.$refs.list.setTable(this.Special);
    //   if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
    //   if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
    //   if (this.tabName === "4") this.$refs.list.setTable(this.Combination);
    // },
    reload() {
      this.$refs.list.reload()
      //this.$refs['info' + this.tabName].clear()
      if (this.tabName === '0') {
        this.$refs['info0'].clear()
      } else {
        this.$refs['info1'].clear()
      }
    },
    tabClick() {
      this.tempParams.Stage = Number(this.tabName)
      this.$refs.list.getData()

      this.$nextTick(() => {
        //this.$refs['info' + this.tabName].setData([])
        this.workInfo = []
        if (this.tabName === '0') {
          this.$refs['info0'].setData(this.workInfo)
        } else {
          this.$refs['info1'].setData(this.workInfo)
        }
      })

      // if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      // if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      // if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      // if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      // if (this.tabName === "4") this.$refs.list.setTable(this.Combination);
      // this.$refs.list.getData({ Stage: this.tabName });
      this.$emit('tabChange', this.tabName)
    },
    async onSelect(row) {
      // this.$refs["info" + this.tabName].setData(row.PlanId);
      let workInfo = []
      const { Data } = await this.api.getWorkDocProductTest({
        WorkDocId: row.WorkDocId
      })
      if (Data && JSON.stringify(Data) !== '{}') {
        // console.log(res.Data);
        workInfo = [Data]
      }
      // console.log(this.workInfo);
      //this.$refs['info' + this.tabName].setData(workInfo)
      if (this.tabName === '0') {
        this.$refs['info0'].setData(workInfo)
      } else {
        this.$refs['info1'].setData(workInfo)
      }
    },
    onCheck(data) {
      this.checkList = data
    }
    // edit(row) {
    //   var name = "edit" + this.tabName + "Dialog";
    //   this.$refs[name].openCreate({ ...row, Stage: this.tabName });
    // },
  }
}
</script>
